import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';

import 'Layouts/default';

import 'Ui/slider';

Swiper.use([Pagination, Navigation, Autoplay]);
